// @flow
import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import classNames from 'classnames';
import Expand from 'assets/images/upb.png';
import Collapse from 'assets/images/downb.png';
import { useViewport } from 'components/templates/viewportProvider';
import 'animate.css/animate.css';
import Carousel from 'react-bootstrap/Carousel';
import { BannerImageLayout } from 'components/atoms/bannerImageLayout';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  imageUrl: string,
  title?: string,
  containerClassName?: string,
  fillWidth?: boolean,
  fillHeight?: boolean,
  descriptionClass?: string,
  descriptionHeading?: string,
  thumbNailUrl?: string,
  description?: string,
  bannerImage?: string,
  onClick?: void,
  bannerText?: string,
  length?: number,
  variableWidth?: boolean,
  altImageName?: string,
  socialIcons?: Object<SocialIcon>,
  imageId?: number,
  titleHeading?: string,
};

type SocialIcon = {
  faceBook: string,
  instagram: string,
  twitter: string,
};

export const Banner = (props: Props) => {
  const { isMobile } = useViewport();
  const {
    containerClassName = '',
    descriptionHeading,
    descriptionClass,
    thumbNailUrl,
    description,
    titleHeading,
    bannerImage,
    bannerText,
    imageUrl,
    title,
    fillHeight = true,
    fillWidth = true,
    variableWidth = false,
    length,
    altImageName,
    socialIcons,
    imageId,
    isCarousal = false,
    carousal_data,
  } = props;
  const [isCropped, expand] = useState(false);
  const handleClick = () => {
    expand(!isCropped);
    let banner_description_element = document.getElementsByClassName(
      'banner-description'
    )[0];
    let is_active_element = banner_description_element.classList.contains(
      'is-active'
    );
    let is_collapsed_element = banner_description_element.classList.contains(
      'is-collapsed'
    );
    if (is_active_element) {
      banner_description_element.classList.remove('is-active');
      banner_description_element.classList.add('is-collapsed');
    }
    if (!is_active_element && !is_collapsed_element) {
      // for first time click event.
      banner_description_element.classList.add('is-active');
    }
    if (is_collapsed_element) {
      banner_description_element.classList.remove('is-collapsed');
      banner_description_element.classList.add('is-active');
    }
  };

  const containerClassNames = classNames(
    'banner-container',
    containerClassName
  );
  const bannerClassNames = classNames('banner-image', bannerImage, {
    'banner-fill-height': fillHeight,
    'banner-fill-width': fillWidth,
  });
  const textClassNames = classNames('text banner-text', bannerText);

  const descriptionClassNames = classNames(
    'banner-description is-active',
    descriptionClass
  );

  const renderDescription = () => {
    if (description || descriptionHeading) {
      if (isCropped) {
        return (
          <div className={descriptionClassNames}>
            {descriptionHeading && (
              <h4 className="description-heading">{descriptionHeading}</h4>
            )}
            {description}
            {length > 51 && (
              <div
                className={'toggle-description-height'}
                onClick={handleClick}
              >
                <img src={Expand} alt={'banner'} />
              </div>
            )}
          </div>
        );
      } else {
        return (
          <div className={descriptionClassNames}>
            {descriptionHeading && (
              <h4 className="description-heading">{descriptionHeading}</h4>
            )}
            <div className="description">{description}</div>
            {length > 51 && (
              <div
                className={'toggle-description-height'}
                onClick={handleClick}
              >
                <img src={Collapse} alt={'banner'} />
              </div>
            )}
          </div>
        );
      }
    }
  };

  const renderCarousalBanner = () => (
    <Carousel
      className={`banner-carousal ${containerClassName}`}
      interval={5000}
      pause={false}
      pauseOnHover={false}
    >
      {carousal_data.map((banner, idx) => {
        return (
          <Carousel.Item key={idx}>
            <BannerImageLayout
              thumbNailUrl={isMobile ? banner.mobile_image : banner.thumbnail}
              bannerClassNames={bannerClassNames}
              imageUrl={isMobile ? banner.mobile_image : banner.image}
              altImageName={''}
              variableWidth={variableWidth}
              textClassNames={textClassNames}
              title={banner.title}
            />
          </Carousel.Item>
        );
      })}
    </Carousel>
  );

  return (
    <Row className={containerClassNames}>
      {isCarousal ? (
        renderCarousalBanner()
      ) : (
        <BannerImageLayout
          thumbNailUrl={thumbNailUrl}
          bannerClassNames={bannerClassNames}
          imageUrl={imageUrl}
          altImageName={altImageName}
          imageId={imageId}
          variableWidth={variableWidth}
          titleHeading={titleHeading}
          textClassNames={textClassNames}
          title={title}
        />
      )}
      {!isMobile && socialIcons ? socialIcons : ''}
      {renderDescription()}
    </Row>
  );
};
